<template>
  <v-dialog v-model="display" persistent max-width="600px" v-if="display">
    <v-card>
      <v-card-title>Préparation de l'archive des dossiers</v-card-title>
      <v-card-subtitle>{{ progress.fichier }}</v-card-subtitle>
      <v-card-text>
        <v-progress-linear
          v-model="progress.avancement"
          height="25"
          striped
          color="primary"
        >
          <template v-slot="{ value }">
            <strong>{{ value }}%</strong>
          </template>
        </v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ModalZipProgress",
  props: ["progress", "display"]
};
</script>
